import { makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import React, { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';

//Table
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import MyTable from '../../../utils/MyTable';

import { useDispatch } from "react-redux";
import { headerSearch, unoTheme } from "../../../../assets/styles/unoTheme";
import { greenOrRed } from "../../../utils/utils";
import XLSX from 'xlsx';
import { downloadBlob, s2ab } from "../../../../controllers/ExcelController";
import { getMonthName } from "../../../utils/utils";
import allActions from '../../../../actions';

const rightDivWidth = 450;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        height: '100%',
        width: '100%',
    },
    headerSearch: headerSearch,

    inputSearch: {
        width: "300px",
        background: "white"
    },
    tableContainer: {
        padding: '0px 18px 16px 18px',
        borderRadius: '10px 0px 0px 10px',
    },
    table: {
        tableLayout: 'fixed',
        '& .MuiTableRow-head': {
            '& .MuiTableCell-root': {
                backgroundColor: 'white',
                borderBottom: 'none',
                color: unoTheme.defaultTextColor,
                fontWeight: '500',
                textTransform: 'uppercase',
                fontSize: '12px',
                padding: '16px 24px 16px 16px',
            },
        },
    },
    clickableHead: {
        cursor: 'pointer',
    },
    accordionNewClient: {
        marginBottom: theme.spacing(2),
    },
    heading: {
        display: 'flex',
        alignItems: 'center'
    },
    labelHeading: {
        marginTop: '2px'
    },
    rootForm: {
        // '& .MuiTextField-root': {
        //     margin: theme.spacing(1),
        //     width: '25ch',
        // },
        textAlign: "left",
    },
    progressInput: {
        width: '20px !important',
        height: '20px !important',
    },
    myDatePicker: {
        marginTop: '-6px'
    },
    green: {
        color: unoTheme.greenMoney
    },

    leftChart: {
        padding: theme.spacing(2),
        width: '50%',
    },

    leftHeaderDetail: {
        display: "flex",
        alignItems: "baseline",
    },
    rightHeader: {
        display: 'flex',
        alignItems: 'center',
    },

    //RightDiv
    mainRoot: {
        height: '100%',
        width: '100%',
        transition: 'all .3s ease',
    },

    sectionTableCellData: {
        width: '30%',
        display: 'table-cell',
        padding: '0px !important',
        fontSize: '12px',
    },

    sectionTableCell: {
        display: 'table-cell',
        color: 'white',
        padding: '0px !important',
        fontSize: '12px',
    },
    multipleHorizontalTableCell: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        justifyContent: 'space-around',
        '& > div': {
            width: '50%',
        }
    },

}));

export default function RiskBenchmarksScreen(props) {

    const { data, flagDoExcelRiskBenchmarks, resetFlag } = props;

    const classes = useStyles();

    const dispatch = useDispatch();

    useEffect(() => {
        if (flagDoExcelRiskBenchmarks) {
            if (data && data.length > 0) {
                doExcelRiskBenchmarks(
                    "BENCHMARKS_RISCO_" + new Date().toISOString().split('T')[0],
                    data
                );
            }
            resetFlag();
        }
    }, [flagDoExcelRiskBenchmarks, data, resetFlag]);

    function doExcelRiskBenchmarks(titleFile, benchmarksData) {
        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            loadMessage: 'Gerando planilha de Benchmarks...',
        }));

        const wb = XLSX.utils.book_new();
        wb.Props = {
            Title: "Benchmarks de Risco",
            Author: "UNO",
        }

        const sheetName = "Benchmarks Risco";
        wb.SheetNames.push(sheetName);

        const ws_data = [];

        // Cabeçalhos
        ws_data.push([
            'Fundo',
            'Saldo',
            'Benchmark',
            'Rent. Mês (%)',
            'Rent. 3m (%)',
            'Rent. 6m (%)',
            'Rent. 12m (%)',
            'Rent. vs Bench Mês (%)',
            'Rent. vs Bench 3m (%)',
            'Rent. vs Bench 6m (%)',
            'Rent. vs Bench 12m (%)'
        ]);

        // Dados
        benchmarksData.forEach(row => {
            ws_data.push([
                row.fund_name,
                row.balance_now,
                row.benchmark,
                row.rentMonth,
                row.rent3m,
                row.rent6m,
                row.rent12m,
                row.benchmarkVsFund?.rentMonth || '-',
                row.benchmarkVsFund?.rent3m || '-',
                row.benchmarkVsFund?.rent6m || '-',
                row.benchmarkVsFund?.rent12m || '-'
            ]);
        });

        const ws = XLSX.utils.aoa_to_sheet(ws_data);
        wb.Sheets[sheetName] = ws;
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

        downloadBlob(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), titleFile + '.xlsx');

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: false,
        }));
    }

    return (
        <div className={classes.root}>

            <div className={classes.mainRoot}>
                <div class={'defaultScrollWithHeaderContent'}>
                    <div>
                        <MyTable
                            stickyHeader>
                            {/* <colgroup>
                                <col width="25%" />
                                <col width="15%" />
                                <col width="7%" />
                                <col width="7%" />
                            </colgroup> */}
                            <TableHead>
                                <TableRow>

                                    <TableCell align="left">Fundo</TableCell>
                                    <TableCell align="right">Saldo</TableCell>
                                    <TableCell align="center">Benchmark</TableCell>
                                    <TableCell className={[classes.sectionTableCell].join(' ')} align="center">
                                        <div>{'Rentabilidade (%)'}</div>
                                        <div className={classes.multipleHorizontalTableCell}>
                                            <div>{'Mês'}</div>
                                            <div>{'3m'}</div>
                                            <div>{'6m'}</div>
                                            <div>{'12m'}</div>
                                        </div>
                                    </TableCell>
                                    <TableCell className={[classes.sectionTableCell].join(' ')} align="center">
                                        <div>{'Rent. vs Benchmarks (%)'}</div>
                                        <div className={classes.multipleHorizontalTableCell}>
                                            <div>{'Mês'}</div>
                                            <div>{'3m'}</div>
                                            <div>{'6m'}</div>
                                            <div>{'12m'}</div>
                                        </div>
                                    </TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data && data.map((row, index) => (
                                    <TableRow key={'diarys-' + index}>


                                        <TableCell align="left">{row.fund_name}</TableCell>
                                        <TableCell align="right" style={{ color: greenOrRed(row.balance_now) }}>{row.balance_now}</TableCell>
                                        <TableCell align="center">{row.benchmark}</TableCell>
                                        <TableCell align="center" className={[classes.sectionTableCellData].join(' ')}>
                                            <div className={classes.multipleHorizontalTableCell}>
                                                <div>{row.rentMonth}</div>
                                                <div>{row.rent3m}</div>
                                                <div>{row.rent6m}</div>
                                                <div>{row.rent12m}</div>
                                            </div>
                                        </TableCell>
                                        <TableCell align="center" className={[classes.sectionTableCellData].join(' ')}>
                                            <div className={classes.multipleHorizontalTableCell}>
                                                <div>{row.benchmarkVsFund.rentMonth}</div>
                                                <div>{row.benchmarkVsFund.rent3m}</div>
                                                <div>{row.benchmarkVsFund.rent6m}</div>
                                                <div>{row.benchmarkVsFund.rent12m}</div>
                                            </div>
                                        </TableCell>

                                    </TableRow>
                                ))}
                            </TableBody>
                        </MyTable>
                    </div>

                </div>


            </div>

        </div>
    );
}



